// prop-type is a library for typechecking of props
import PropTypes from "prop-types";
import { useEffect } from "react";

import { useParams } from "react-router-dom";

import Fields from "./components/fields";
import { useSelector } from "react-redux";
import { authSelector } from "redux/selector";

function CompanyInfo({ formData, data }) {
  const { id } = useParams();
  const { setFieldValue } = formData;
  const { user } = useSelector(authSelector);

  useEffect(() => {
    // Update Form Field Value
    if (!data || !id) return;
    Object.entries(data).map((field) => {
      setFieldValue(field?.[0], field?.[1]);
    });
    setFieldValue("logo", { preview: data.logo });
    setFieldValue("email", data?.owner?.email || "");
  }, [id, data, user]);

  return <Fields formData={formData} />;
}

// typechecking props for CompanyInfo
CompanyInfo.propTypes = {
  data: PropTypes.any,
  formData: PropTypes.oneOfType([PropTypes.object, PropTypes.func]).isRequired,
};

export default CompanyInfo;
